/* eslint-disable @typescript-eslint/naming-convention */
export default {
  TermsOfServicesEn: () => import('./TermsOfServicesEn.vue'),
  TermsOfServicesEs: () => import('./TermsOfServicesEs.vue'),
}
